import type { AnimationClip } from 'three';
import { preloadGLTF } from '@/lib/avatarPreloader';
import { isMpRiggedClipUrl } from './animationClipPolicy';

/** External animation is an explicit registered GLB opt-in; unregistered URLs never fetch. */
export async function loadExternalAnimationClip(url: string): Promise<AnimationClip | null> {
  if (!isMpRiggedClipUrl(url)) return null;
  const gltf = await preloadGLTF(url);
  const clip = gltf.animations?.[0];
  // Callers may filter tracks; the shared cache must retain the original clip.
  return clip ? clip.clone() : null;
}
